import { render } from "./tempLandingPage.vue?vue&type=template&id=246c3542"
import script from "./tempLandingPage.vue?vue&type=script&lang=js"
export * from "./tempLandingPage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\c2stem\\c2stem-classroom\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__